export default __webpack_public_path__ + "static/media/arrow-long.b48839f3.svg";